import { render, staticRenderFns } from "./assist.vue?vue&type=template&id=5fb0b268&scoped=true"
import script from "./assist.vue?vue&type=script&lang=js"
export * from "./assist.vue?vue&type=script&lang=js"
import style0 from "./assist.vue?vue&type=style&index=0&id=5fb0b268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb0b268",
  null
  
)

export default component.exports